import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { datricApi } from '../../../services/api/datric.api';
import { CreditTransaction } from '../../../models/credit.model';
import { toastService } from '../../../services/toast.service';

export interface CreditState {
	balance: number;
	statement: CreditTransaction[];
	loading: boolean;
}

const initialState: CreditState = {
	balance: 0,
	statement: [],
	loading: false
};

export const fetchBalance = createAsyncThunk('credit/balance', async () => {
	const res = await datricApi.credit.balance();
	return res.balance;
});

export const fetchStatement = createAsyncThunk('credit/statement', async (_, { rejectWithValue }) => {
	try {
		return await datricApi.credit.statement();
	} catch (e: any) {
		toastService.error(typeof e === 'string' ? e : 'Falha ao carregar extrato');
		return rejectWithValue(e);
	}
});

export const creditSlice = createSlice({
	name: 'credit',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchBalance.fulfilled, (state, action) => {
			state.balance = action.payload;
		});
		builder.addCase(fetchStatement.pending, state => {
			state.loading = true;
		});
		builder.addCase(fetchStatement.fulfilled, (state, action) => {
			state.loading = false;
			state.statement = action.payload as CreditTransaction[];
		});
		builder.addCase(fetchStatement.rejected, state => {
			state.loading = false;
		});
	}
});
